import { useEffect, useState } from 'react';
import { webhooksApi } from '../../api/admin.js';

const EVENT_LIST = [
  'issue.created', 'issue.updated', 'issue.status.changed',
  'deal.won', 'deal.stage.changed',
  'payroll.processed', 'release.deployed',
  'purchase_order.approved', 'leave.approved', 'document.approved',
  'user.invited',
];

export default function Webhooks() {
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [details, setDetails] = useState(null);
  const [deliveries, setDeliveries] = useState([]);
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);

  function refresh() { webhooksApi.list().then((d) => setItems(d?.items || [])); }
  useEffect(refresh, []);

  async function submit(e) {
    e.preventDefault();
    setError(null);
    const fd = new FormData(e.currentTarget);
    const events = [...e.currentTarget.querySelectorAll('input[name=event]:checked')].map((i) => i.value);
    if (!events.length) { setError('Pick at least one event'); return; }
    try {
      const r = await webhooksApi.create({ name: fd.get('name'), url: fd.get('url'), events });
      setInfo(`Created. Secret: ${r.subscription.secret}`);
      e.currentTarget.reset();
      setShowForm(false);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed');
    }
  }

  async function showDeliveries(sub) {
    setDetails(sub);
    const d = await webhooksApi.deliveries(sub.id);
    setDeliveries(d?.items || []);
  }

  async function test(id) {
    await webhooksApi.test(id, 'webhook ping from BOS+');
    setInfo('Test event queued');
  }

  return (
    <section>
      <header className="page-header">
        <h1>Webhooks</h1>
        <button className="btn primary" onClick={() => setShowForm((s) => !s)}>{showForm ? 'Close' : '+ New Subscription'}</button>
      </header>
      {error && <div className="alert error">{error}</div>}
      {info && <div className="alert info">{info}</div>}

      {showForm && (
        <form onSubmit={submit} className="card form-card">
          <div className="grid-form">
            <label>Name<input name="name" required /></label>
            <label>URL<input name="url" type="url" required placeholder="https://example.com/hooks/bosplus" /></label>
          </div>
          <h4>Events</h4>
          <div className="vendor-grid">
            {EVENT_LIST.map((evt) => (
              <label key={evt} className="vendor-pick">
                <input type="checkbox" name="event" value={evt} /> <span>{evt}</span>
              </label>
            ))}
          </div>
          <div className="actions"><button className="btn primary" type="submit">Create</button></div>
        </form>
      )}

      <div className="card">
        <table className="data-table">
          <thead><tr><th>Name</th><th>URL</th><th>Events</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {items.map((s) => {
              const events = typeof s.events === 'string' ? JSON.parse(s.events) : s.events;
              return (
                <tr key={s.id}>
                  <td><strong>{s.name}</strong></td>
                  <td className="muted small">{s.url}</td>
                  <td>{events?.length} event(s)</td>
                  <td><span className={`chip status-${s.is_active ? 'active' : 'cancelled'}`}>{s.is_active ? 'active' : 'paused'}</span></td>
                  <td>
                    <button className="btn ghost small" onClick={() => test(s.id)}>Test</button>
                    <button className="btn ghost small" onClick={() => showDeliveries(s)}>Deliveries</button>
                  </td>
                </tr>
              );
            })}
            {items.length === 0 && <tr><td colSpan={5} className="muted">No subscriptions.</td></tr>}
          </tbody>
        </table>
      </div>

      {details && (
        <div className="card">
          <header className="page-header">
            <h3>Deliveries · {details.name}</h3>
            <button className="btn ghost small" onClick={() => setDetails(null)}>✕</button>
          </header>
          <table className="data-table">
            <thead><tr><th>Event</th><th>Status</th><th>Code</th><th>Attempts</th><th>Created</th><th>Body</th></tr></thead>
            <tbody>
              {deliveries.map((d) => (
                <tr key={d.id}>
                  <td><code>{d.event_type}</code></td>
                  <td><span className={`chip status-${d.status === 'delivered' ? 'approved' : d.status === 'failed' ? 'rejected' : 'pending'}`}>{d.status}</span></td>
                  <td>{d.response_status || '—'}</td>
                  <td>{d.attempts}</td>
                  <td className="muted small">{new Date(d.created_at).toLocaleString()}</td>
                  <td className="muted small" style={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis' }}>{d.response_body || '—'}</td>
                </tr>
              ))}
              {deliveries.length === 0 && <tr><td colSpan={6} className="muted">No deliveries yet.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
